import { useMemo } from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import {
    Accordion, AccordionContent, AccordionItem, AccordionTrigger
} from "@/components/ui/accordion";
import {
    Smartphone, CreditCard, Monitor, Building, Wallet, Store, BookOpen
} from "lucide-react";

export default function PaymentGuideIndonesia() {
    const paymentMethods = useMemo(() => [
        {
            id: "wondr",
            title: "Wondr By BNI",
            icon: Smartphone,
            steps: [
                "Akses Wondr By BNI kemudian masukkan user ID dan password;",
                "Pilih menu 'Virtual Account Billing';",
                "Pilih Tujuan Baru;",
                "Masukkan 16 digit nomor Virtual Account Anda (contoh: 9881234500001946) pada menu 'Nomor Virtual Account';",
                "Tagihan yang harus dibayarkan akan muncul pada layar konfirmasi, pilih lanjut;",
                "Konfirmasi transaksi dan pilih transaksi sekarang;",
                "Masukkan PIN transaksi, Pembayaran Anda telah berhasil."
            ]
        },
        {
            id: "atm-bni",
            title: "ATM BNI",
            icon: CreditCard,
            steps: [
                "Masukkan Kartu Anda;",
                "Pilih Bahasa;",
                "Masukkan PIN ATM Anda;",
                "Pilih 'Menu Lainnya';",
                "Pilih 'Transfer';",
                "Pilih Jenis rekening yang akan Anda gunakan (Contoh: 'Dari Rekening Tabungan');",
                "Pilih 'Virtual Account Billing';",
                "Masukkan 16 digit Nomor Virtual Account Anda (contoh: 9881234500001946);",
                "Tagihan yang harus dibayarkan akan muncul pada layar konfirmasi;",
                "Konfirmasi, apabila telah sesuai, lanjutkan transaksi;",
                "Transaksi telah selesai."
            ]
        },
        {
            id: "bnidirect",
            title: "BNIDirect",
            icon: Monitor,
            steps: [
                "Ketik alamat https://bnidirect.bni.co.id kemudian klik 'Enter';",
                "Masukkan Company ID, User ID dan Password kemudian klik 'Masuk';",
                "Pilih menu 'Pembayaran Tagihan';",
                "Pilih 'Pembayaran Tagihan';",
                "Klik radio button pada kolom 'Rekening Pengirim';",
                "Pada kolom 'Penerima' pilih 'Penerima Baru' dan pilih 'Institusi' yakni 'VA Billing Open Payment / Closed Payment';",
                "Masukkan nama pada kolom 'Nama Penerima';",
                "Kemudian input 16 digit nomor Virtual Account pada kolom 'Nomor VA' (contoh: 9881234500001946);",
                "Klik 'Lanjutkan' dan pilih 'Jenis Instruksi' lalu klik 'Lanjutkan';",
                "Pada layar muncul Konfirmasi Pembayaran Tagihan;",
                "Masukkan nominal atau sesuai kewajiban Anda pada kolom 'Nominal';",
                "Konfirmasi dan 'Submit';",
                "Selanjutnya user Approver dan Releaser dapat melakukan otorisasi pada menu 'Daftar Tugas' untuk memasukkan Kode Otentikasi Token/OTP;",
                "Pembayaran Anda telah berhasil."
            ]
        },
        {
            id: "sms-bni",
            title: "BNI SMS Banking",
            icon: Smartphone,
            steps: [
                "Buka aplikasi BNI SMS Banking;",
                "Pilih menu 'Transfer';",
                "Pilih menu 'Transfer rekening BNI';",
                "Masukkan nomor rekening tujuan dengan 16 digit Nomor Virtual Account (contoh: 9881234500001946);",
                "Masukkan nominal transfer sesuai tagihan atau kewajiban Anda. Nominal yang berbeda tidak dapat diproses;",
                "Pilih 'Proses' kemudian 'Setuju';",
                "Reply sms dengan ketik PIN sesuai perintah;",
                "Transaksi berhasil."
            ]
        },
        {
            id: "teller-bni",
            title: "Kantor Cabang / Teller BNI",
            icon: Building,
            steps: [
                "Kunjungi Kantor Cabang/Outlet BNI terdekat;",
                "Informasikan kepada Teller, bahwa ingin melakukan pembayaran 'Virtual Account Billing';",
                "Serahkan 16 digit nomor Virtual Account Anda kepada Teller. (contoh: 9881234500001946);",
                "Teller melakukan konfirmasi kepada Anda;",
                "Teller memproses Transaksi;",
                "Apabila transaksi sukses Anda akan menerima bukti pembayaran dari Teller tersebut."
            ]
        },
        {
            id: "agen46",
            title: "Agen46",
            icon: Store,
            steps: [
                "Kunjungi Agen46 terdekat (warung/toko/kios dengan tulisan Agen46);",
                "Informasikan kepada Agen46, bahwa ingin melakukan pembayaran 'Virtual Account Billing';",
                "Serahkan 16 digit Nomor Virtual Account Anda kepada Agen46;",
                "Agen46 melakukan konfirmasi kepada Anda;",
                "Agen46 Proses Transaksi;",
                "Apabila transaksi sukses, Anda akan menerima bukti pembayaran dari Agen46 tersebut."
            ]
        },
        {
            id: "atm-lain",
            title: "ATM Bank Lain",
            icon: CreditCard,
            steps: [
                "Masukkan kartu ke mesin ATM Bank Lain;",
                "Pilih 'Transaksi Lainnya';",
                "Pilih menu 'Transfer';",
                "Pilih 'Transfer ke Bank Lain';",
                "Masukkan kode bank BNI (009) dan 16 digit Nomor Virtual Account (contoh: 9881234500001946);",
                "Masukkan nominal transfer sesuai tagihan atau kewajiban Anda (nominal yang berbeda tidak dapat diproses);",
                "Konfirmasi rincian Anda akan tampil di layar, cek dan tekan 'Ya' untuk melanjutkan;",
                "Transaksi berhasil."
            ]
        },
        {
            id: "ebanking-lain",
            title: "e-Banking / Mobile Bank Lain",
            icon: Smartphone,
            steps: [
                "Pilih menu 'Transfer Antar Bank' atau 'Transfer Online Antar Bank';",
                "Masukkan kode bank BNI (009) atau pilih bank yang dituju yaitu BNI;",
                "Masukan 16 digit Nomor Virtual Account pada kolom rekening tujuan (contoh: 9881234500001946);",
                "Masukkan nominal transfer sesuai tagihan atau kewajiban Anda (nominal yang berbeda tidak dapat diproses);",
                "Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan lanjutkan transaksi sampai dengan selesai;",
                "Transaksi berhasil."
            ]
        },
        {
            id: "teller-lain",
            title: "Kantor Cabang Bank Lain",
            icon: Building,
            steps: [
                "Menuju counter Teller untuk menyampaikan kelengkapan formulir transfer dan melakukan transaksi dengan pilihan metode SKN/LLG atau RTGS;",
                "Memastikan pengisian formulir antara lain:\n• Nomor rekening penerima diisi 16 digit Nomor Virtual Account Anda.\n• Nama penerima diisi sesuai yang tercantum pada invoice (contoh: Nama Siswa).\n• Nama Bank tujuan diisi BNI.\n• Nominal transfer diisi sesuai tagihan atau kewajiban Anda.",
                "Teller memproses Transaksi;",
                "Apabila transaksi sukses Anda akan menerima bukti pembayaran dari Teller tersebut."
            ]
        },
        {
            id: "ovo",
            title: "OVO",
            icon: Wallet,
            steps: [
                "Buka aplikasi OVO;",
                "Pilih menu Transfer;",
                "Pilih 'Rekening Bank';",
                "Masukkan kode bank BNI (009) atau pilih bank yang dituju yaitu BNI;",
                "Masukan 16 digit Nomor Virtual Account pada kolom rekening tujuan (contoh: 9881234500001946);",
                "Masukkan nominal transfer sesuai tagihan;",
                "Pilih 'Transfer';",
                "Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan pilih 'Konfirmasi';",
                "Transaksi berhasil."
            ]
        },
        {
            id: "dana",
            title: "DANA",
            icon: Wallet,
            steps: [
                "Buka aplikasi DANA;",
                "Pilih menu 'Send' kemudian menu 'Send to Bank Account';",
                "Pilih 'Rekening Bank';",
                "Masukkan nama bank yang dituju yaitu BNI;",
                "Masukan 16 digit Nomor Virtual Account pada kolom rekening tujuan (contoh: 9881234500001946);",
                "Klik 'Add New Bank' kemudian masukkan nominal transfer sesuai tagihan;",
                "Pilih 'Confirm';",
                "Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan pilih 'Konfirmasi';",
                "Transaksi berhasil."
            ]
        },
        {
            id: "gopay",
            title: "GoPay",
            icon: Wallet,
            steps: [
                "Buka aplikasi GoPay;",
                "Pilih menu 'Pay' kemudian menu 'to Bank Account';",
                "Pilih 'Rekening Bank';",
                "Masukkan nama bank yang dituju yaitu BNI;",
                "Masukan 16 digit Nomor Virtual Account pada kolom rekening tujuan;",
                "Klik 'Verify' dan 'Continue' kemudian masukkan nominal transfer sesuai tagihan;",
                "Pilih 'Confirm';",
                "Konfirmasi rincian Anda akan tampil di layar, cek dan konfirmasi;",
                "Transaksi berhasil."
            ]
        },
        {
            id: "doku",
            title: "DOKU",
            icon: Wallet,
            steps: [
                "Buka aplikasi DOKU;",
                "Pilih menu 'Transfer' kemudian menu 'Akun Bank' dan 'Pilih Bank';",
                "Masukkan nama bank yang dituju yaitu BNI;",
                "Masukan 16 digit Nomor Virtual Account pada kolom rekening tujuan;",
                "Masukkan nominal transfer sesuai tagihan;",
                "Pilih 'Konfirmasi';",
                "Konfirmasi rincian Anda akan tampil di layar, cek dan apabila sudah sesuai silahkan pilih 'Kirim';",
                "Transaksi Berhasil."
            ]
        }
    ], []);

    return (
        <Card className="border shadow-sm rounded-2xl bg-white dark:bg-slate-900 overflow-hidden pt-0">
            <CardHeader className="bg-slate-50/80 dark:bg-slate-900/50 border-b border-slate-100 dark:border-slate-800 md:px-8">
                <CardTitle className="flex items-center gap-3 text-lg md:text-xl font-bold text-slate-800 dark:text-slate-100 pt-8">
                    <BookOpen className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                    Langkah Pembayaran Virtual Account
                </CardTitle>
                <CardDescription className="text-sm text-slate-500 dark:text-slate-400">
                    Jika Anda memilih Virtual Account, ikuti instruksi sesuai dengan platform yang Anda gunakan.
                </CardDescription>
            </CardHeader>

            <CardContent className="p-6 md:p-8">
                <Accordion type="single" collapsible className="w-full grid grid-cols-1 md:grid-cols-2 gap-x-6 gap-y-2">
                    {paymentMethods.map((method) => {
                        const Icon = method.icon;
                        return (
                            <AccordionItem key={method.id} value={method.id} className="border-b-slate-100 dark:border-b-slate-800">
                                <AccordionTrigger className="hover:no-underline hover:bg-slate-50 dark:hover:bg-slate-800/50 px-3 rounded-lg transition-colors py-4">
                                    <div className="flex items-center gap-3 text-left">
                                        <div className="p-2 rounded-md bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-300">
                                            <Icon className="w-4 h-4" />
                                        </div>
                                        <span className="text-sm font-semibold text-slate-700 dark:text-slate-200">
                                            {method.title}
                                        </span>
                                    </div>
                                </AccordionTrigger>
                                <AccordionContent className="px-3 pb-4 pt-2">
                                    <ol className="list-decimal list-outside pl-5 space-y-2 text-sm text-slate-600 dark:text-slate-400">
                                        {method.steps.map((step, idx) => (
                                            <li key={idx} className="pl-1 leading-relaxed whitespace-pre-line">
                                                {step}
                                            </li>
                                        ))}
                                    </ol>
                                </AccordionContent>
                            </AccordionItem>
                        );
                    })}
                </Accordion>
            </CardContent>
        </Card>
    );
}